import { Menu as AntMenu, MenuProps } from "antd";

export default function Menu(props: MenuProps) {
  return <AntMenu {...props} />;
}
